export default "__VITE_ASSET__4fe905b8__"